var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyScenarios(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 140H66.6667C75.3748 140 82.783 134.435 85.5286 126.667H120C123.682 126.667 126.667 123.682 126.667 120V93.3334C126.667 89.6518 123.682 86.6672 120.001 86.6668L86.6667 120V101.144L118.032 69.7799C120.635 67.1764 120.635 62.9553 118.032 60.3518L99.6491 41.9689C97.0456 39.3654 92.8245 39.3654 90.221 41.9689L86.6667 45.5232V40C86.6667 36.3386 85.6828 32.907 83.965 29.9552C91.7248 24.8549 102.253 25.7168 109.077 32.5409L127.46 50.9238C134.284 57.7477 135.146 68.2759 130.046 76.0355C135.998 79.5001 140 85.9494 140 93.3334V120C140 131.046 131.046 140 120 140Z",
    fill: "#22252C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6667 33.3333H40C36.3181 33.3333 33.3333 36.3181 33.3333 40V120C33.3333 123.682 36.3181 126.667 40 126.667H66.6667C70.3486 126.667 73.3333 123.682 73.3333 120V40C73.3333 36.3181 70.3486 33.3333 66.6667 33.3333ZM40 20C28.9543 20 20 28.9543 20 40V120C20 131.046 28.9543 140 40 140L66.6667 140C77.7124 140 86.6667 131.046 86.6667 120V40C86.6667 28.9543 77.7124 20 66.6667 20H40Z",
    fill: "#22252C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 106.667C60 110.349 57.0152 113.333 53.3333 113.333C49.6514 113.333 46.6667 110.349 46.6667 106.667C46.6667 102.985 49.6514 100 53.3333 100C57.0152 100 60 102.985 60 106.667Z",
    fill: "#22252C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyScenarios);
export default __webpack_public_path__ + "static/media/empty-scenarios.d243d710d843c820d48efb64831350b6.svg";
export { ForwardRef as ReactComponent };